import { Link } from 'gatsby';
import styled from 'styled-components';
import background from '../../images/pdficon.png';

export const SectionBreadCrumb = styled.div`
  padding: 50px 0 0;

  @media (max-width: 575.98px) {
    padding: 30px 0 0;
  }

  &.download-file {
    .download_sectionhead {
      padding-left: 0px;
      padding-right: 0px;
    }

    .download_title {
      max-width: 900px;
      font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '16px')};
      line-height: 20px;
      color: #4a4a4a;
      margin: 0 0 10px;

      &[dir='ltr'] {
        letter-spacing: 1.29px;
        font-family: 'DINRegular';
      }
    }

    .container_breadcrumb {
      padding-left: 15px;
      padding-right: 15px;

      @media (max-width: 575.98px) {
        padding: 0px 30px;
      }
    }
  }

  .container_breadcrumb {
    padding: 0px;
  }
  h3 {
    @media (max-width: 1199.98px) {
      font-size: 18px;
    }
    @media (max-width: 767.98px) {
      font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '16px')};
    }
  }
`;

export const SectionHead = styled.div`
  position: relative;
  padding-left: 3rem;
  padding-right: 3rem;

  p {
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
    font-size: 16px;
    line-height: 20px;
    color: #4a4a4a;

    &[dir='ltr'] {
      font-family: 'DINRegular';
      letter-spacing: 1.29px;
    }

    @media (max-width: 991.98px) {
      color: #898989;
      font-size: 13px;
    }
  }

  .btn_breadcrumn {
    text-align: right;

    @media (max-width: 767.98px) {
      margin-top: 1.5rem;
      text-align: left;
    }

    @media (max-width: 575.98px) {
      margin-top: 1.5rem;
      text-align: left;
    }
  }
`;

export const SectionTypes = styled.div`
  padding: 50px 0 0;
`;

export const DownloadWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  @media (min-width: 575.98px) {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
`;

export const PdfIcon = styled.div`
  margin: 0px;
  vertical-align: middle;
  width: 54px;
  height: 36px;
  background: url(${background}) no-repeat center;
  background-size: contain;

  @media (min-width: 575.98px) {
    margin-bottom: 1.5rem;
  }
`;

export const DownloadLabel = styled(Link)`
  &[dir='ltr'] {
    font-family: 'DINRegular';
    letter-spacing: 1.29px;
  }

  font-size: 12px;
  line-height: 16px;
  text-decoration: underline solid rgb(206, 68, 91);
  text-align: center;
  text-transform: uppercase;
  word-spacing: 0px;
  background-color: #ffffff;
  background-position: 0% 0%;
  color: #ce445b;
  cursor: pointer;
  margin: 0 5px 1.5rem;

  @media (min-width: 576px) {
    margin-bottom: 1.5rem;
  }
`;

export const DownloadSize = styled.span`
  font-family: 'DINRegular';
  font-size: 12px;
  letter-spacing: 1.29px;
  line-height: 16px;
  text-decoration: none solid rgb(0, 0, 0);
  text-align: center;
  text-transform: uppercase;
  word-spacing: 0px;
  white-space: nowrap;

  @media (min-width: 576px) {
    margin-bottom: 1.5rem;
  }
`;
